export default __webpack_public_path__ + "static/media/art-1-main-lg.5208c9a2.jpg";